import { apiFetch } from '@app/lib/api'
import type { SyncStatusPayload } from '../../../worker/api/sync.types'

/**
 * Data-freshness endpoint. The payload type comes from the Worker contract
 * (`worker/api/sync.types.ts`), so the chip and the API share one shape.
 *
 * Session-authed but not role-gated: how old the data is, is metadata every
 * account may read.
 */

export type * from '../../../worker/api/sync.types'

export const syncApi = {
  status: () => apiFetch<SyncStatusPayload>('/sync/status'),
}

export const syncQueryKeys = {
  all: ['sync'] as const,
  status: () => ['sync', 'status'] as const,
}
